import type { StoryObj } from "@storybook/react";
import Newsletter from "../components/Cards/Newsletter";

const meta = {
    title: "Example/Newsletter",
    component: Newsletter,
};

export default meta;
type Story = StoryObj<typeof meta>;

export const NewsletterYellowInput: Story = {};
export const NewsletterYellow: Story = {
    args: {
        title: "Funktionsstörungen im Energiefeld lösen viele Probleme aus. Wenn Beratungen nicht helfen, ist die Fernbehandlung die richtige Wahl.",
        hasDescription: true,
        description:
            "Um Probleme zu lösen braucht es Kraft. Wenn Energiefelder funktionieren, ist sie da.",
        buttonText: "HEUTE NOCH BEGINNEN",
        hasInput: false,
        hasCheckbox: false,
        hasSubText: false,
        backgroundColor: "bg-yellow",
    },
};

export const NewsletterBlue: Story = {
    args: {
        title: "Warte nicht länger - pack es an!",
        backgroundColor: "bg-blue",
        hasDescription: true,
        description:
            "Meine Arbeit hat das Ziel, dir nachhaltig in deine natürliche Kraft und Stärke zu helfen. Veränderung ist nur durch Stärke möglich und dazu braucht es funktionierende Energiefelder.",
        buttonText: "HEUTE NOCH BEGINNEN",
        hasInput: false,
        hasCheckbox: false,
        hasSubText: false,
    },
};
export const NewsletterBlueInput: Story = {
    args: {
        title: "Informiere mich, wenn es neue Videos gibt",
        backgroundColor: "bg-blue",
        hasInput: true,

        inputText: "Deine E-Mail-Adresse",
        buttonText: "Absenden und up do date bleiben",
        hasCheckbox: false,
        hasSubText: true,
        checkBoxText: "Ich möchte informiert werden, wenn es neue Videos gibt",

        subText: "Ich möchte informiert werden, wenn es neue Videos gibt",
    },
};
export const NewsletterOrange: Story = {
    args: {
        title: "Warte nicht länger - pack es an!",
        hasDescription: true,
        backgroundColor: "bg-orange",
        hasInput: false,
        hasCheckbox: false,
        hasSubText: false,
        description:
            "Meine Arbeit hat das Ziel, dir nachhaltig in deine natürlich Kraft und Stärke zu helfen. Veränderung ist nur durch Stärke möglich und dazu braucht es funktionierende Energiefelder.",
        buttonText: "HEUTE NOCH BEGINNEN",
    },
};

export const NewsletterTurquoiseInput: Story = {
    args: {
        title: "Ich möchte informiert werden, wenn es neue Videos gibt.",
        backgroundColor: "bg-turquoise",
        hasInput: true,
        inputText: "Deine E-Mail-Adresse",
        buttonText: "Absenden und up-do-date bleiben",
        hasCheckbox: false,

        hasSubText: true,
        subText: "Die Abmeldung vom Newsletter ist jederzeit möglich.",
    },
};
